import { useEffect } from 'react'
import NProgress from 'nprogress'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

export const useLoadProgressBar = () => {
  const router = useSafeRouter()

  useEffect(() => {
    if (router) {
      router.events.on('routeChangeStart', NProgress.start)
      router.events.on('routeChangeComplete', NProgress.done)
      router.events.on('routeChangeError', NProgress.done)
    }

    return () => {
      if (router) {
        router.events.off('routeChangeStart', NProgress.start)
        router.events.off('routeChangeComplete', NProgress.done)
        router.events.off('routeChangeError', NProgress.done)
      }
    }
  }, [router])
}
